import { Component, OnDestroy, OnInit } from "@angular/core";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { GlobalJobordersService } from "src/app/_services/global-joborders.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { forkJoin } from "rxjs";
import { AuthenticationService } from 'src/app/auth/authentication.service';

@Component({
  selector: "app-add-status",
  templateUrl: "./add-status.component.html",
  styleUrls: ["./add-status.component.scss"],
  standalone: false,
})
export class AddStatusComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  defaultColor: string = "#FFFFFF";
  jobTypeAssignments = [];
  jobTypeAssignmentsSpliced = []; //first 10 records to show in UI
  profileAssignments = [];
  profileAssignmentsSpliced = []; //first 10 records to show in UI

  data: any;
  statusCategories: any = [];
  statusInfoForm: FormGroup;
  jobOrderTypes: any;
  profiles: any;
  statusInfo: any;
  showAllJobTypes: boolean = false;
  showAllProfiles: boolean = false;
  isCustomerPortalAvailable: boolean = false;
  addonFeature: any;

  constructor(
    public modalRef: BsModalRef,
    private globalJOServc: GlobalJobordersService,
    private languageTranslateService: LanguageTranslateService,
    private errorUtil: ErrorUtil,
    private bsModalServc: BsModalService,
    private auth: AuthenticationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.statusCategories = this.data.categories;

    //check customer portal addon
    /*this.addonFeature = this.auth.getAddonFeatureLists();
    var tenantPackageCustomerPortal =
      this.auth.getPackageCodeWithList("CUSTOMER_PORTAL");
    if (localStorage.getItem("packageCode") == "Old") {
      // Check if the package is old
      this.isCustomerPortalAvailable =
        this.addonFeature.addonCustomerPortal == "CUSTOMER_PORTAL"
          ? true
          : false;
    } else {
      if (this.auth.getAddonPackageListsToHide("CUSTOMER_PORTAL")) {
        this.isCustomerPortalAvailable =
          tenantPackageCustomerPortal.addonPackageList == "CUSTOMER_PORTAL" ||
          this.addonFeature.addonCustomerPortal == "CUSTOMER_PORTAL"
            ? true
            : false;
      } else {
        this.isCustomerPortalAvailable = false;
      }
    }*/

    let profileInfo: any = JSON.parse(this.auth.getProfileInfo());
    this.isCustomerPortalAvailable = profileInfo.isCustomerPortalEnabled;

    this.defaultColor = this.generateBrightColorHex();
    this.statusInfoForm = new FormGroup({
      statusCategory: new FormControl("", Validators.required),
      statusLabel: new FormControl("", Validators.required),
      statusLabelPortal: new FormControl(
        "",
        this.isCustomerPortalAvailable ? Validators.required : [],
      ),
      statusCode: new FormControl("", Validators.required),
      statusColor: new FormControl(this.defaultColor, [
        Validators.required,
        Validators.pattern(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/),
      ]),
      defaultColor: new FormControl(this.defaultColor),
      jobType: new FormControl([]),
      profiles: new FormControl([]),
    });

    if (this.data.mode) {
      if (!this.data.from) {
        //statusData
        this.statusInfoForm.patchValue({
          statusCategory: this.data.statusData.category,
          statusLabel: this.data.statusData.label,
          statusCode: this.data.statusData.code,
          statusColor: this.data.statusData.color,
          defaultColor: this.data.statusData.color,
          statusLabelPortal: this.data.statusData.customerPortalLabel,
        });
      } else {
        //from picklist
        this.statusInfoForm.patchValue({
          statusCategory: this.data.statusData.category,
          statusLabel: this.data.statusData.fieldLabel,
          statusCode: this.data.statusData.name,
          statusColor: this.data.statusData.colorCode,
          defaultColor: this.data.statusData.colorCode,
          statusLabelPortal: this.data.statusData.customerPortalLabel,
        });
      }
    }

    let sources = [
      this.globalJOServc.getJobOrderTypes(true),
      this.globalJOServc.getProfiles(),
    ];

    if (this.data.mode) {
      //edit mode
      let statusId: any = this.data.from
        ? this.data.statusData.id
        : this.data.statusData.joStatusId;
      sources.push(this.globalJOServc.getJOStatusById(statusId));
    }

    forkJoin(sources).subscribe(
      ([joTypeResponse, joProfileResponse, joStatusResponse]) => {
        let jobOrderTypes: any = joTypeResponse;
        this.jobOrderTypes = jobOrderTypes;
        this.statusInfo = joStatusResponse;
        let profileList: any = joProfileResponse;
        this.profiles = profileList;

        if (!this.data.mode) {
          //create mode
          let foundIdx = this.jobOrderTypes.findIndex((item: any) => {
            return item.id === this.data.joTypeId;
          });
          if (foundIdx >= 0) {
            this.jobTypeAssignments.push(this.jobOrderTypes[foundIdx]);
            this.jobOrderTypes.splice(foundIdx, 1);
          }
        } else {
          //edit mode
          this.statusInfo.jobOrderType.map((joType: any) => {
            let idx: number = this.jobOrderTypes.findIndex((item: any) => {
              return item.id === joType.id;
            });
            if (idx >= 0) {
              this.jobTypeAssignments.push(this.jobOrderTypes[idx]);
              this.jobOrderTypes.splice(idx, 1);
            }
          });

          this.statusInfo.profile.map((profile: any) => {
            let profileIdx = this.profiles.findIndex((item: any) => {
              return item.id === profile.id;
            });
            if (profileIdx >= 0) {
              this.profileAssignments.push(this.profiles[profileIdx]);
              this.profiles.splice(profileIdx, 1);
            }
          });

          this.profileAssignmentsSpliced = this.profileAssignments.slice(0, 10);
        }
        //show first 10 records only. Show all when toggle to cilck Show More
        this.jobTypeAssignmentsSpliced = this.jobTypeAssignments.slice(0, 10);
      },
      (error: any) => {
        console.log(error, "error in forkJoin printing..");
      },
    );
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  onColorPickerChange(event: any) {
    this.statusInfoForm.patchValue({ statusColor: event.value });
  }

  removeProfile(itemToRemove: any, index: number) {
    // let currentFormValue: any = this.statusInfoForm.get('profiles').value;
    // let removedIdx: number = currentFormValue.indexOf(itemToRemove.id);
    // currentFormValue.splice(removedIdx, 1);
    // //remove the item in form and set new values
    // this.statusInfoForm.patchValue({
    //   profiles: currentFormValue
    // })
    this.profileAssignments.splice(index, 1);
    //find the index in profileAssignmentsSpliced to remove
    let idx: number = this.profileAssignmentsSpliced.findIndex((jt: any) => {
      return jt.id === itemToRemove.id;
    });
    if (idx >= 0) {
      this.profileAssignmentsSpliced.splice(idx, 1);
    }
    this.profiles.push(itemToRemove);
  }

  removeJobType(itemToRemove: any, index: number) {
    let currentFormValue: any = this.statusInfoForm.get("jobType").value;
    //let removedIdx: number = currentFormValue.indexOf(itemToRemove.id);
    //currentFormValue.splice(removedIdx, 1);
    //remove the item in form and set new values
    // this.statusInfoForm.patchValue({
    //   jobType: currentFormValue
    // })
    this.jobTypeAssignments.splice(index, 1);
    //find the index in jobTypeAssignmentsSpliced to remove
    let idx: number = this.jobTypeAssignmentsSpliced.findIndex((jt: any) => {
      return jt.id === itemToRemove.id;
    });
    if (idx >= 0) {
      this.jobTypeAssignmentsSpliced.splice(idx, 1);
    }
    //add back to the list
    this.jobOrderTypes.push(itemToRemove);
  }

  onAddJOType() {
    // this.jobTypeAssignments = [];
    let selectedJOTypes: any = this.statusInfoForm.get("jobType").value;
    //selectedJOTypes.map ((jo: any) =>{
    let foundIdx = this.jobOrderTypes.findIndex((item: any) => {
      return item.id === selectedJOTypes;
    });
    this.jobTypeAssignments.push(this.jobOrderTypes[foundIdx]);
    //take first 10 records if show more toggle is NOT on (To prevent jobTypeAssignmentsSpliced to get refreshed in UI)
    if (!this.showAllJobTypes) {
      this.jobTypeAssignmentsSpliced = this.jobTypeAssignments.slice(0, 10);
    }
    this.statusInfoForm.controls["jobType"].reset();
    //remove it from the list after added
    this.jobOrderTypes.splice(foundIdx, 1);
    //})
  }

  onAddProfile() {
    // this.profileAssignments = [];
    let selectedProfiles: any = this.statusInfoForm.get("profiles").value;
    //selectedProfiles.map ((profile: any) =>{
    let foundIdx = this.profiles.findIndex((item: any) => {
      return item.id === selectedProfiles;
    });
    this.profileAssignments.push(this.profiles[foundIdx]);
    //take first 10 records if show more toggle is NOT on (To prevent profileAssignmentsSpliced to get refreshed in UI)
    if (!this.showAllProfiles) {
      this.profileAssignmentsSpliced = this.profileAssignments.slice(0, 10);
    }
    this.statusInfoForm.controls["profiles"].reset();
    this.profiles.splice(foundIdx, 1);
    //})
  }

  onFormSubmit() {
    if (this.statusInfoForm.valid) {
      const selectedJobTypes = this.jobTypeAssignments.map((item) => ({
        id: item.id,
        name: item.name,
      }));

      if (!this.data.mode) {
        //create
        let payload: any = {
          jobOrderStatus: {
            name: this.statusInfoForm.get("statusCode").value,
            fieldLabel: this.statusInfoForm.get("statusLabel").value,
            customerPortalLabel:
              this.statusInfoForm.get("statusLabelPortal")?.value,
            active: true,
            systemValue: false,
            isDefault:
              this.statusInfoForm.get("statusCategory").value == "SCHEDULED"
                ? true
                : false,
            colorCode: this.statusInfoForm.get("statusColor").value,
            category: this.statusInfoForm.get("statusCategory").value,
          },
          jobOrderType: selectedJobTypes,
          profile: this.profileAssignments,
        };
        this.globalJOServc.createJobOrderTypeStatus(payload).subscribe(
          (res: any) => {
            if (res.status == 201) {
              this.errorUtil.setErrorMessage(
                200,
                "Status added successfully",
                null,
                "success",
                3000,
              );

              let jsonObj: any = {
                id: res.body[0]?.jobOrderStatus?.id,
                reason: "status-added",
              };
              this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
              this.modalRef.hide();
            }
          },
          (err: any) => {
            // handle error here
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000,
            );
          },
        );
      } else {
        //update
        let payload = {
          jobOrderStatus: {
            id: this.data.from
              ? this.data.statusData.id
              : this.data.statusData.joStatusId,
            name: this.statusInfoForm.get("statusCode").value,
            fieldLabel: this.statusInfoForm.get("statusLabel").value,
            customerPortalLabel:
              this.statusInfoForm.get("statusLabelPortal")?.value,
            order: this.statusInfo.jobOrderStatus.order,
            colorCode: this.statusInfoForm.get("statusColor").value,
            isDefault: this.data.statusData.isDefault,
            active: true,
            systemValue: this.data.statusData.systemValue,
            category: this.statusInfoForm.get("statusCategory").value,
          },
          jobOrderType: selectedJobTypes,
          profile: this.profileAssignments,
        };

        this.globalJOServc.updateJobOrderTypeStatus(payload).subscribe(
          (res: any) => {
            if (res.status == 200) {
              this.errorUtil.setErrorMessage(
                200,
                this.translate?.setup.modules.types.sections.sec2.singular +
                  " " +
                  this.translate?.general.messages.updatedSuccessfully,
                null,
                "success",
                3000,
              );

              let jsonObj: any = {
                id: res.body[0]?.jobOrderStatus?.id,
                reason: "status-updated",
              };
              this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
              this.modalRef.hide();
            }
          },
          (err: any) => {
            // handle error here
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000,
            );
          },
        );
      }
    } else {
      this.statusInfoForm.markAllAsTouched();
    }
  }

  onCancelClick() {
    this.bsModalServc.setDismissReason("cancelled");
    this.modalRef.hide();
  }

  onLabelChange() {
    let statusLabelValue = this.statusInfoForm.get("statusLabel")?.value;
    let formattedLabel = statusLabelValue
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "_");
    this.statusInfoForm.patchValue({
      statusCode: formattedLabel,
    });
  }

  generateBrightColorHex() {
    let color = "#";
    // Ensure at least one component is high for brightness
    const highValue = 200 + Math.floor(Math.random() * 56); // 200-255
    const lowValue = Math.floor(Math.random() * 100); // 0-99

    const components = [highValue, lowValue, lowValue];
    // Shuffle the components to randomize which one is high
    components.sort(() => Math.random() - 0.5);

    for (let i = 0; i < 3; i++) {
      let hex = components[i].toString(16);
      color += hex.length === 1 ? "0" + hex : hex;
    }
    return color;
  }

  onShowMoreToggle(category: string) {
    if (category == "jobType") {
      this.showAllJobTypes = !this.showAllJobTypes;
      if (this.showAllJobTypes === true) {
        this.jobTypeAssignmentsSpliced = this.jobTypeAssignments;
      } else {
        this.jobTypeAssignmentsSpliced = this.jobTypeAssignments.slice(0, 10);
      }
    } else {
      this.showAllProfiles = !this.showAllProfiles;
      if (this.showAllProfiles === true) {
        this.profileAssignmentsSpliced = this.profileAssignments;
      } else {
        this.profileAssignmentsSpliced = this.profileAssignments.slice(0, 10);
      }
    }
  }

  onColorInputChange(){
    const inputControl = this.statusInfoForm.get("statusColor");
    if (!inputControl?.value || inputControl.invalid) {
      return;
    }

    this.defaultColor = inputControl.value;
    this.statusInfoForm.patchValue({ defaultColor: this.defaultColor });
  }
}
